export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // outbound grey,
  MAIN_COLOR: '#1D3C34', // outbound seaweed
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#55B6B1', // outbound teal
  SECONDARY_COLOR: '#55B6B1', // outbound teal
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
